module.exports = __webpack_public_path__ + "static/media/dark-chevron-right-icon.3b0171f5.svg";